<template>
  <div>
    <page-title
      icon="fa fa-file-alt"
      main="Relatórios"
      sub="Frota - Km/L"
      :help="true"
      content="Página responsável por criar/listar registros de frota.
      Caso o filtro de data não seja aplicado antes de executar a ação 'Gerar Relatório' serão listados os registro do período de um mês.">
      <template v-slot:actions>
        <base-button
          @click="form = true"
          type="neutral"
          class="ml-3"
          size="sm"
          >Inserir Novo</base-button
        >
      </template>
    </page-title>
    <modal :show.sync="form" class="col-12">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">{{newFuelTransaction && newFuelTransaction.id ? 'Editar' : 'Novo'}} Registro de Frota</h5>
      </template>
      <fuel-transaction-form
        :fuelTransaction.sync="newFuelTransaction"
        @save="clear"
        @close="clear"
      />
    </modal>
    <filters @filter="handleFilter" :loading="loading" />
    <Table :filter="filtro" :loading.sync="loading" @edit="handleEdit" />
  </div>
</template>
<script setup>
import { ref } from 'vue';
import PageTitle from "@/layouts/PageTitle";
import FuelTransactionForm from "@/views/FuelTransactions/Components/Form.vue";
import Filters from './components/FuelUsage/Filters.vue';
import Table from './components/FuelUsage/Table.vue';

const filtro = ref({});
const loading = ref(false);

const handleFilter = (filterData) => {
  filtro.value = filterData;
  console.log("filters in handle",filtro.value);
};

const form = ref(false);

const handleEdit = (fuelTransaction) => {
  console.log("chegou aqui")
  newFuelTransaction.value = { ...fuelTransaction };
  form.value = true;
};

const newFuelTransaction = ref({
  license_plate: null,
  utilization_date: null,
  driver: null,
  fuel_type: null,
  volume: null,
  unitary_value: null,
  total_value: null,
  pedometer_before: null,
  pedometer: null,
  km_traveled: null,
  average: null,
  cost_per_km: null,
});

const clear = () => {
  form.value = false;
  newFuelTransaction.value = {
    license_plate: null,
    utilization_date: null,
    driver: null,
    fuel_type: null,
    volume: null,
    unitary_value: null,
    total_value: null,
    pedometer_before: null,
    pedometer: null,
    km_traveled: null,
    average: null,
    cost_per_km: null
  }
};

</script>